<template>
    <b-row>
        <b-col v-show="edit">
            <b-spinner
                v-if="loading"
                variant="primary"
                class="align-middle"
                small
            />
            <div v-show="!loading">
                <slot name="edit" />
            </div>
        </b-col>
        <b-col
            v-show="!edit"
            @click="edit = true"
        >
            <slot name="value">
                {{ value }}
            </slot>
        </b-col>
        <b-col
            md="1"
        >
            <i
                class="icon cursor-pointer"
                :class="{'icon-edit': !edit, 'icon-times': edit}"
                @click="edit = !edit"
            />
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'EditField',
    props: {
        value: {
            type: [String, Number],
            'default': '',
        },

        isEdit: {
            type: Boolean,
            'default': false,
        },

        loading: {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            edit: this.isEdit,
        };
    },

    watch: {
        edit: function() {
            return this.$emit('update:isEdit', this.edit);
        },

        isEdit: function() {
            this.edit = this.isEdit;
        },
    },
};
</script>